import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { get } from 'lodash';
import { observer } from 'mobx-react';
import { browserHistory } from 'react-router';
import StudentAccessFrequencyTable from './StudentAccessFrequencyTable';
import { StudentAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';

class StudentAccessFrequencyTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
  };

  constructor(props) {
    super(props);
    StudentAccessFrequencyListService.load();
  }

  render() {
    return (
      <StudentAccessFrequencyTable
        loading={
          StudentAccessFrequencyListService.fetchCurrent.fetching ||
          StudentAccessFrequencyListService.fetchPrevious.fetching
        }
        values={toJS(
          get(
            StudentAccessFrequencyListService,
            { segment: 'bySegment', distributor: 'byDistributor' }[this.props.type],
            []
          )
        )}
        feedbackColorRender={StudentAccessFrequencyListService.getFeedbackColor}
        onSelect={(row) => browserHistory.push(`/kpis/customer-success/${this.props.type}/${row.id}/details`)}
        formatter={StudentAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentAccessFrequencyTableContainer);
